import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  Field,
  Input,
  Heading,
  VStack,
  Text,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { toast } from '../utils/toast';

const ResendVerification: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
      toast({ title: 'Error', description: 'Please enter your email.', status: 'error' });
      return;
    }
    setLoading(true);
    setSent(false);
    try {
      await authAPI.resendVerification(email.trim());
      setSent(true);
      toast({
        title: 'Success',
        description: 'If an account exists and is not verified, we have sent a new link to the email.',
        status: 'success',
      });
    } catch (error: any) {
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Sending failed.',
        status: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gray.50"
      px={4}
    >
      <Container maxW="md">
        <Box bg="white" p={10} borderRadius="2xl" boxShadow="lg">
          <VStack gap={6} align="stretch">
            <Box textAlign="center">
              <Heading size="lg" mb={2}>New verification link</Heading>
              <Text color="gray.600" fontSize="sm">
                The link in the email is valid for 24 hours. If it has expired, enter your email and we will send a new one.
              </Text>
            </Box>

            {sent ? (
              <VStack gap={4}>
<Text color="green.600" fontWeight="medium">
                Check your inbox (and spam) for the new link.
              </Text>
                <Button variant="outline" onClick={() => navigate('/login')}>
                  Back to login
                </Button>
              </VStack>
            ) : (
              <form onSubmit={handleSubmit}>
                <VStack gap={5}>
                  <Field.Root required>
                    <Field.Label>Email</Field.Label>
                    <Input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="your@email.com"
                      size="lg"
                      borderRadius="lg"
                    />
                  </Field.Root>
                  <Button
                    type="submit"
                    width="100%"
                    size="lg"
                    loading={loading}
                    colorScheme="purple"
                    borderRadius="lg"
                  >
                    Send new link
                  </Button>
                </VStack>
              </form>
            )}

            <Button variant="ghost" size="sm" onClick={() => navigate('/login')}>
              ← Back to login
            </Button>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default ResendVerification;
